import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  return <section className="py-16 bg-aged-cream relative overflow-hidden" data-id="element-150">
      <div className="container mx-auto px-4" data-id="element-151">
        <div className="max-w-3xl mx-auto" data-id="element-152">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-8" data-id="element-153">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9,
            y: 30
          }} whileInView={{
            opacity: 1,
            scale: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            ease: [0.22, 1, 0.36, 1]
          }} className="relative pb-12" data-id="element-154">
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-155">
                <div className="w-64 h-64 bg-yellow-400/10 rounded-full blur-3xl" data-id="element-156" />
              </div>

              <div className="relative max-w-sm mx-auto" data-id="element-157">
                <img src="https://cdn.magicpatterns.com/uploads/uoPbiQbJ5CGezKPYEGfgPV/MilagrodelSobre.png" alt="El Milagro del Sobre - Libro" className="w-full h-auto rounded-lg shadow-2xl" data-id="element-158" />
              </div>
            </motion.div>

            <div className="relative pl-6 border-l-4 border-[#1a3d3d]" data-id="element-159">
              <h2 className="text-3xl md:text-4xl font-bold text-[#1a3d3d] mb-4" data-id="element-160">
                Cobraste. Respiraste.
              </h2>
              <p className="text-xl text-[#2d4a3a] leading-relaxed" data-id="element-161">
                Te prometiste que esta vez sí ibas a hacerlo diferente. Ibas a
                organizarte. A no gastar "de más". A llegar tranquila a fin de
                quincena.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl border border-[#e8dcc8] shadow-lg relative overflow-hidden" data-id="element-162">
              <div className="absolute top-0 right-0 w-32 h-32 bg-yellow-400/10 rounded-full -mr-16 -mt-16 blur-2xl" data-id="element-163" />

              <h3 className="text-2xl font-bold text-[#1a3d3d] mb-4" data-id="element-164">
                Y aun así...
              </h3>
              <p className="text-lg text-[#2d4a3a] mb-6" data-id="element-165">
                El dinero volvió a desaparecer. No hubo un gasto enorme. No hubo
                una emergencia. Fueron cafés. Comida. Cosas "chiquitas".
              </p>
              <p className="text-lg text-[#1a3d3d] font-medium" data-id="element-166">
                Y de pronto estás otra vez ahí.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-167">
              <div className="bg-aged-green p-6 rounded-xl shadow-md border-t-4 border-[#f4c430] hover:-translate-y-1 transition-transform duration-300 overflow-hidden" data-id="element-168">
                <p className="text-white font-medium relative z-10" data-id="element-169">
                  Revisando la cuenta con miedo.
                </p>
              </div>
              <div className="bg-aged-green p-6 rounded-xl shadow-md border-t-4 border-[#f4c430] hover:-translate-y-1 transition-transform duration-300 overflow-hidden" data-id="element-170">
                <p className="text-white font-medium relative z-10" data-id="element-171">
                  Haciendo cuentas mentales.
                </p>
              </div>
              <div className="bg-aged-green p-6 rounded-xl shadow-md border-t-4 border-[#f4c430] hover:-translate-y-1 transition-transform duration-300 md:col-span-2 overflow-hidden" data-id="element-172">
                <p className="text-white font-medium text-center relative z-10" data-id="element-173">
                  Preguntándote en qué momento se fue todo.
                </p>
              </div>
            </div>

            <div className="text-center pt-8" data-id="element-174">
              <p className="text-xl md:text-2xl font-bold text-[#1a3d3d]" data-id="element-175">
                Si esto te suena familiar, sigue leyendo. <br data-id="element-176" />
                <span className="text-[#f4c430]" data-id="element-177">
                  Porque el problema no es lo que crees.
                </span>
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}